import React, { useContext, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, Outlet, useNavigate } from 'react-router-dom';
import logo from './candleman200.png';
import './App.css';
import {host} from './env'
import { AuthContext } from './AuthContext';
import TickerSearch from './TickerSearch';



function Layout() {

  const { isLoggedIn, setIsLoggedIn } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = async () => {
    await fetch( host + "/logout", {
      method: "POST",
      credentials: "include",
    });
    setIsLoggedIn(false);
    navigate("/login");
  };

  var now = new Date();
  var month = now.getMonth() + 1;
  var monthStr = '';
  if (month < 10) {
    monthStr = '0' + month;
  } else {
    monthStr = month + '';
  }

  var dateStr = now.getDate() + '';
  if (now.getDate() < 10) {
    dateStr = '0' + now.getDate();
  }


  

  return (
    <div className="App">
      <div className="login-register-logout">
        <span>
          <Link to="/register">Register</Link>|
          {!isLoggedIn ? (
            <Link to="/login">Login</Link>
          ) : (
            <button onClick={handleLogout}>Logout</button>
          )}
        </span>
      </div>
      <header className="container">
        <img src={logo} width="150" height="150" className="" alt="logo" />
        <div className="search-input">
          {' '}
          <span>Search:</span> <TickerSearch />
        </div>
      </header>

      <div>
        <nav>
          <Link to="/hvc">HVC </Link> |
          <Link to="/relativePerformanceIncreases">RS performers </Link> |
          {/* <Link to="/sectorIndustryGainers">Industry Gainers</Link>
          <Link to="/">High Volume </Link> | <Link to="/gainers">Gainers</Link>{' '} */}
          {/* | <Link to="/most-active">Most Active</Link> | |{' '} */}
          <Link to="/qualityStocks">Quality</Link> |{' '}
          <Link to="/smallCapLeaders">Smallcap Leaders</Link> |{' '}
          {/* <Link to="/positionSizeCalculator">
            ATR based position size calculator
          </Link>{' '}
          | <Link to="/iposWithinOneYear">IPOs within 1 yr.</Link> |{' '}
          <Link to="/newSymbols">New Symbols</Link> |{' '} */}

        </nav>
        <div>
          <Outlet></Outlet>
        </div>
      </div>
      <span className="avwapp-title box">avwapp</span>
    </div>
  );
}

export default Layout;
